import { render, staticRenderFns } from "./Planprogrami.vue?vue&type=template&id=46345667"
import script from "./Planprogrami.vue?vue&type=script&lang=js"
export * from "./Planprogrami.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports